import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useSupervisoresOutletContext } from 'pages/Supervisor.context'
import { useParams } from 'react-router-dom'
import { supervisor } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirSupervisor() {
    const { id } = useParams()
    const { data } = useSupervisoresOutletContext()
    const s = data?.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } = supervisor.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!s) return null

    const handleSubmit = () =>
        mutateAsync(s.id, {
            onSuccess: () => {
                toast.success('Supervisor excluído com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <ConfirmarExclusao
            permissao={['delete', 'Supervisores']}
            loading={isLoading}
            onConfirm={handleSubmit}
            title={<>Realmente deseja excluir o supervisor {s.nome}?</>}
        />
    )
}
